<template>

    <div class="hpBenefits reveal">

        <!-- nav -->
        <!--
        <div class="sideNavContainer">
            <sidepager 
                @item-change ="sidepagerOnChange"
                :skinMode="1"
                v-bind:itemIndex="selectedIndex" 
                v-bind:sectionIndex="Number(secIndex)">
            </sidepager>
        </div>
        -->
        <!-- nav -->

        <div class="bnContainer">
            <div class="sectionTitle black fsTitle">
                {{ms_localize(sectionData.title)}}
                <!-- <splitter :content="ms_localize(sectionData.title)"></splitter> -->
            </div>

            <div class="bnCols">
                
                <div class="bnScrollerWrapper" id="bnScrollerWrapper">
                    <div class="bnImgContainer" ref="bnImgScroll1" id="imgBnScroller1">                    
                        <div class="bnImgScroll" > 
                            <img :class="['bnImgItem',selectedIndex == index ? 'active' : '']"
                                v-for="(item, index) in sectionData.items" 
                                :key="index"
                                :src="item[2]" />
                        </div>                    
                    </div>
                </div>
                
                <div class="mobileNavContainer">
                    <sidepager                         
                        @item-change ="sidepagerOnChange"
                        v-bind:skinMode="1"
                        v-bind:itemIndex="selectedIndex" 
                        v-bind:sectionIndex="1">
                    </sidepager>
                </div> 
                
                <div class="bnText" v-if="elementTitle.length>0">
                    <div class="bnFeatureTitle">
                        <div>{{ms_localize(elementTitle)}}</div>
                        <!-- <splitter :content="ms_localize(elementTitle)"></splitter> -->
                    </div>  
                    <div class="bnFeatureDesc">
                        <div>{{ms_localize(elementDesc)}}</div>
                        <!-- <splitter :content="ms_localize(elementDesc)"></splitter> -->
                    </div>
                    <div class="sideNavContainer">
                        <sidepager 
                            @item-change ="sidepagerOnChange"
                            :skinMode="1"
                            v-bind:itemIndex="selectedIndex" 
                            v-bind:sectionIndex="Number(secIndex)">
                        </sidepager>
                    </div>

                </div>
                
            </div>
            <!--
            <ul class="cols">
                <li v-for="(item, index) in sectionData.items" :key="index">
                    <div class="col-title">{{item[0]}}</div>
                    <div class="col-desc">{{item[1]}}</div>
                </li>
            </ul>
            -->

        </div>
    </div>
</template>

<style>    
    .splitter .black
    {
        color:#202020;        
    }
    .hpBenefits
    {
        width: 100vw;
        height: 100%;
        background-color: var(--graybg1);
        z-index: 100;
        display: grid;
        align-items: center;
    }
    .hpBenefits .bnContainer
    {
      width: 100vw;
      __padding-left: max(180px, 10vw);      
      __padding-right: max(180px, 10vw);    
    }
    .section-title
    {
        font-size: 40px;
        text-align: center;
        color: #fff;
        letter-spacing: 0px;
    }
    .bnCols 
    {
        display: grid;
        justify-items: center;
        grid-template-columns: repeat(2, minmax(115px, 1fr));  
        margin:auto;
        width:110vh;
        max-width: 1200px;
        gap: 50px;
        /* grid-row-gap: 2rem;  Will be used instead by browsers that do not support `row-gap` */
        /* row-gap: 2rem; Used by browsers that support `row-gap` */        
    }

    .bnScrollerWrapper
    {
        width: 50vh;
        height: 50vh;
    }

    .hpBenefits .bnImgContainer
    {
        width: 50vh;
        height: 50vh;
        overflow: hidden;
        border-radius: 100%;
        background-color: #02182d;
        display: none;  
        opacity: 0;
        transition: all ease-in 0.5s;
        transition-delay: 0.5s;
    }
    .hpBenefits .bnImgContainer::-webkit-scrollbar {
        display: none;
    }
    .bnScrollerWrapper.show .bnImgContainer
    {
        display: block;
        opacity: 0;
    }
    .bnScrollerWrapper.showOpaq .bnImgContainer
    {
        opacity: 1;
    }

    .hpBenefits .bnImgContainer .bnImgScroll
    {
        width: 250vh;        
        position: relative;
    }

    /*
    .hpBenefits.active .bnImgContainer .bnImgScroll
    {
        display: block;
    }
    */

    .bnImgContainer .bnImgScroll img
    {
        width: 50vh;
        height: auto;
        position: absolute;
        top: 0px;
        left: 0px;
/*         float: left;
        scroll-snap-align: start;
        scroll-snap-stop: normal;
 */    }
    

    .bnText
    {
        display: grid;
        align-content: center;
    }
    .bnText .bnFeatureTitle
    {
        font-size: 22px;
        font-weight: 400 !important;
        font-weight: bold !important;
        color:#202020;
    }
    .bnText .bnFeatureDesc
    {
        padding-top: 10px;
        font-size: 18px;
        line-height: 22px;
        overflow-wrap:break-word;
        color:#202020;
    }

    .__sideNavContainer{
        position: absolute;right: 50px;
    }
    .sideNavContainer{
        padding: 30px 0px 0px 0px;
    }

    @media (min-width: 850px) { 
        .mobileNavContainer{
            display: none; 
        }
        .bnImgContainer .bnImgScroll img{
            opacity: 0;
            transition: all ease 0.8s;
        }
        .bnImgContainer .bnImgScroll img.active{
            opacity: 1;
        }
    }

  @media (max-width: 850px) { 
    .mobileNavContainer
    {
        padding: 30px 0px 0px 0px;
    }
    .sideNavContainer
    {
        display: none;
    }
    .hpBenefits .sideNav.spread {
        width: 86vw;padding: 0px;margin: auto;
    }    
    .hpBenefits
    {
        display:block;
        padding-bottom: 100px;
    }
    .hpBenefits .bnContainer
    {
      width: 100%;
    }
    .bnCols{
        display: block;margin:auto;width:100vw;max-width:100vw;
    }    
    .sideNavContainer{display: none;}
    .hpBenefits .bnContainer
    {
      width: 100vw;
    }
    .bnScrollerWrapper
    {
        width: 70vw;
        height: 70vw;        
        margin: auto;
    }
    .hpBenefits .bnImgContainer
    {
        width: 70vw;
        height: 70vw;        
        margin: auto;
        margin-top: 25px;
        overflow-x:scroll;
        overflow-x:hidden;
        overflow-y: hidden;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */

    }
    .bnImgContainer .bnImgScroll
    {
        width: 400vw;
    }
    .bnImgContainer .bnImgScroll img {
        width: 70vw;
        height: 70vw;        
        height: auto;float: left;
        scroll-snap-align: start;
        scroll-snap-stop: normal;
        position: initial;
    }   
    .bnText
    {
        clear: both;
        padding: 40px 10vw 0px 10vw;
    } 


  }    

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
    }    

</style>



<script>
import { mapActions, mapState } from "vuex";
import sidepager from "@/views/com/sidepager.vue";
import splitter from "@/views/com/splitter.vue";
import { splitLines,isMobileScreen }         from "@/utils";

export default 
{
    components: { sidepager,splitter },
    data()
    {
        return{
            secIndex:1,
            name:'benefits',
            selectedIndex:0,
            elementTitle:'',
            elementDesc:'',
            intChanger:Object
        }
    },
    mounted()
    {
        this.initImgScroller();
        this.setText();        
    },
    destroyed() {
        this.removeImgScroller();
    },
    computed: {
        ...mapState(["xSelectedPlatform","minisite_data","siteVisibleSection"]),
        sectionData()
        {
            return this.minisite_data.SECTIONS[1];
            //let _sectionData = this.siteData.SECTIONS.filter(function(item){
                //return item.section == "benefits";         
            //})            
        }
    },
    watch: {
      '$store.state.siteVisibleSection': function() {
        var vm=this;
        let _siteVisibleSection = this.$store.state.siteVisibleSection;
        if(_siteVisibleSection==2){
            //start the timer
            if(isMobileScreen()==false){
                vm.startAutoChange();
            }
        }
      }
    },

    methods:
    {
        stopAutoChange()
        {
            if(this.intChanger){
                clearInterval(this.intChanger);
            }
        },
        startAutoChange()
        {
            var vm=this;
            //alert("setting interval");
            vm.intChanger = setInterval(() => {
                if(vm.siteVisibleSection==2){
                    vm.moveToNextImage();
                }                
            }, 6500);
        },
        moveToNextImage()
        {
            var vm=this;
            let newIndex = vm.selectedIndex+1;
            if(newIndex>vm.sectionData.items.length-1){
                newIndex=0;                    
            }
            vm.setItem(newIndex,true);                
        },
        initImgScroller() {
            if(isMobileScreen()==true)
            {
                var vm = this;
                let scroller = this.$refs.bnImgScroll1;
                scroller.addEventListener("scroll", vm.checkScrollPosition, false);             
            }
        },
        removeImgScroller() {
            if(isMobileScreen())
            {
                var vm = this;
                let scroller = this.$refs.bnImgScroll1;
                scroller.removeEventListener("scroll", vm.checkScrollPosition);
            }
        },
        checkScrollPosition() {
            //alert("benefits scroll");
            var vm=this;
            let scroller = vm.$refs.bnImgScroll1;
            let scrX = scroller.offsetLeft;
            let scrolledX = scroller.scrollLeft;
            
            var reveals = scroller.querySelectorAll(".bnImgItem");
            for (var i = 0; i < reveals.length; i++) 
            {
                //find the element to highligt 
                //console.log("__scrolledX="+scrolledX);
                //console.log("(scrolledX+scrX) ="+scrolledX+"+"+scrX+" === "+reveals[i].offsetLeft);

                //if((scrolledX+scrX)==reveals[i].offsetLeft){
                if((scrolledX)==reveals[i].offsetLeft){
                    //alert("change from scroller");
                    vm.setItem(i,false);               
                    //console.log("[SELECTED !] vm.selectedIndex="+vm.selectedIndex);
                }
            }
        },
        sidepagerOnChange(index)
        {            
            this.setItem(index,false);
        },  
        setItem(index,fromTimer)
        {
            if(fromTimer==false){
                this.stopAutoChange()
            }
            this.selectedIndex = index;
            this.setText();
            this.scrollImg();
        },
        setText()
        {
            let elData = this.sectionData.items[this.selectedIndex];
            this.elementTitle = elData[0];
            this.elementDesc = elData[1];
        },
        scrollImg()
        {
            if(isMobileScreen()){
                //scroll on mobile version
                //let scrollToElement = this.$refs.bnImgScroll1.getElementsByClassName("bnImgItem")[this.selectedIndex];
                //scrollToElement.scrollIntoView({ behavior:'smooth',inline:'center',block:'nearest'});
            }else{
                //fade in/out relevent images on desktop version

            }

        }
    }
};
</script>

